/**
 * @typedef {import('./Props').default} Props
 * @typedef {import('./State').default} State
 * @typedef {import('../../../../shared/SubscriptionService/Subscription').default} Subscription
 */
import { withSubscriptionService } from '../../../../../service-container';
import captureError from '../../../../../utils/captureError';
import Checkout from '../Checkout/Checkout';
import Loading from '../../../../../shared/Loading';
import React from 'react';

const emptySubscription = Object.freeze({
	agentCount: 0,
	expirationDate: new Date(0),
	isActive: false,
	isContactLimitExceeded: false,
	isRenewing: false,
	priceInCents: 0,
	subscriptionLevels: [],
});

/** @extends {React.Component<Props, State>} */
export class SubscriptionIndex extends React.Component {
	/** @param {Props} props */
	constructor(props) {
		super(props);

		/** @type {State} */
		this.state = {
			isGettingData: true,
			subscription: null,
		};
	}

	/**
	 * @returns {Promise<void>}
	 */
	async componentDidMount() {
		await this.getAndSetSubscriptionData();
		this.setState({ isGettingData: false });
	}

	/**
	 * @returns {Promise<Subscription | null>}
	 */
	// eslint-disable-next-line complexity -- due to lots of bindings it's exceed limit.
	async getAndSetSubscriptionData() {
		try {
			const subscription =
				await this.props.subscriptionService.getGroupSubscription(
					this.props.match.params.groupId
				);

			this.setState({
				subscription,
			});

			return subscription;
		} catch (exception) {
			this.handleException(exception);
			return null;
		}
	}

	/**
	 * @param {unknown} exception
	 * @returns {void}
	 */
	handleException(exception) {
		captureError(exception);

		this.setState({
			isGettingData: false,
		});
	}

	/**
	 * @returns {JSX.Element}
	 */
	render() {
		if (this.state.isGettingData) {
			return <Loading />;
		}

		return (
			<Checkout
				// @ts-ignore -- type declared
				cobranding={this.props.location?.state?.cobranding ?? false}
				groupId={this.props.match.params.groupId}
				hasExistingSubscription={this.state.subscription !== null}
				subscription={this.state.subscription ?? emptySubscription}
			/>
		);
	}
}

export default withSubscriptionService(SubscriptionIndex);
